define([
    "./automaticFlowsModule",
    "text!./automaticFlows.html"
], function (module, automaticFlowsTemplate) {
    "use strict";

    return module.config(["$stateProvider", function ($stateProvider) {
        $stateProvider
            .state("monitoring.automaticFlows", {
                url: "/automaticFlows",
                controller: "automaticFlowsController",
                template: automaticFlowsTemplate,
                data: {
                    group: "group.monitoring.config.automatic.flows",
                    pageTitle: "{{'title.monitoring.automatic.flows' | translate:$stateParams}}"
                }
            });
    }]);
});
